/**
 * 会话列表
 */

import React, {Component} from 'react';
import { ImageView, Gender, Grade, OfficialAuth } from '../../component/user-ui';
import lang from '../../lang';

const OfficeItemView=({item})=>{
	return (
		<div>
			<div className="avatar">
	        	 <span className="ui-img" style={{width: '30px', height: '30px'}}>
					<img  src="//g.cdn.pengpengla.com/oauthgame/html5/20181102/b337ac6311d5b3d03d32838f4253354f.png"/>
				</span>
	        </div>
	        <div className="info">
	            <div className="name">{lang.template('官方客服')}</div>
	        </div>
        </div>
	)
}

const UserChatItemView=({item})=>{
	
	return (
		<div>
			<div className="avatar">
				<ImageView src={item.avatar} size={30} circle/>
            </div>
            <div className="info">
                <div className="name">{item.name}</div>
            </div>
        </div>
	)
}

class ConversationListView extends Component {
	static defaultProps = {
		list: [],
		selectedItem: {}, // 默认选中
		sessionNotice: [],
		talkTo: function(){}
	}

	render() {
		let { sessionNotice, selectedItem } = this.props;
		
		return (
			<div className="conversation-list">
				<ul>
				{ 
					this.props.list.map((item, index)=>{
						let actived = selectedItem.oid == item.oid ? 'actived' : '';
						let noticeNum;

						if (sessionNotice[item.oid] > 0) {
							if ( sessionNotice[item.oid] > 99) {
								noticeNum = <i className="notice-num">99+</i>;
							} else {
								noticeNum = <i className="notice-num">{sessionNotice[item.oid]}</i>;
							}
						}


						if (item.oid == 10005) {
							return (
								<li  className={actived} key={item.oid} data-uid={item.oid} onClick={this.props.talkTo.bind(this, item)}>
					                <OfficeItemView item={item}/>
					                { noticeNum }
					            </li>
							);
						} else {
							return (
								<li  className={actived} key={item.oid} data-uid={item.oid} onClick={this.props.talkTo.bind(this, item)}>
					                <UserChatItemView item={item}/>
					                { noticeNum }
					            </li>
							);
						}
					})
				}
				</ul>
			</div>
		);
	}
}



export default ConversationListView;

export {
	OfficeItemView,
	UserChatItemView
}


// WEBPACK FOOTER //
// ./js/im/views/conversation-list.js